<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); let idx = index; trackBy: trackByFunc">
		<button *ngIf="!isDefaultFilter" type="button" mat-icon-button class="circle-icon-remove" (click)="removeValue(idx)"><mat-icon color="accent" svgIcon="md:remove"></mat-icon></button>
		<button type="button"
			*ngFor="let booleanButton of item; let booleanButtonIndex = index; trackBy: trackByFunc"
			class="checkbox-button" [class.selected]="filter.getValues()[idx][booleanButtonIndex].selected" (click)="buttonClick(filter.getValues()[idx][booleanButtonIndex])">
			{{filter.buttonLabels[booleanButtonIndex]}}
		</button>
	</div>
</ng-container>
